/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetPlatformUsageQueryResponse, GetPlatformUsagePathParams, GetPlatformUsage400, GetPlatformUsage401, GetPlatformUsage403, GetPlatformUsage404, GetPlatformUsage409, GetPlatformUsage500 } from "../../types/platformBillingController/GetPlatformUsage.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getPlatformUsage } from "../../client/platformBillingController/getPlatformUsage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getPlatformUsageQueryKey = (organizationId: GetPlatformUsagePathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/usage', params: {organizationId:organizationId} }] as const

export type GetPlatformUsageQueryKey = ReturnType<typeof getPlatformUsageQueryKey>

export function getPlatformUsageQueryOptions(organizationId: GetPlatformUsagePathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getPlatformUsageQueryKey(organizationId)
        return queryOptions<GetPlatformUsageQueryResponse, ResponseErrorConfig<GetPlatformUsage400 | GetPlatformUsage401 | GetPlatformUsage403 | GetPlatformUsage404 | GetPlatformUsage409 | GetPlatformUsage500>, GetPlatformUsageQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getPlatformUsage(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get usage for tracked features
 * {@link /api/organizations/:organizationId/platform-billing/usage}
 */
export function useGetPlatformUsage<TData = GetPlatformUsageQueryResponse, TQueryData = GetPlatformUsageQueryResponse, TQueryKey extends QueryKey = GetPlatformUsageQueryKey>(organizationId: GetPlatformUsagePathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetPlatformUsageQueryResponse, ResponseErrorConfig<GetPlatformUsage400 | GetPlatformUsage401 | GetPlatformUsage403 | GetPlatformUsage404 | GetPlatformUsage409 | GetPlatformUsage500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getPlatformUsageQueryKey(organizationId)
         

         const query = useQuery({
          ...getPlatformUsageQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetPlatformUsage400 | GetPlatformUsage401 | GetPlatformUsage403 | GetPlatformUsage404 | GetPlatformUsage409 | GetPlatformUsage500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}